<template>
  <v-row wrap justify="center" align="center">
    <v-col cols="5" md="5"><v-img src=/message.svg /></v-col>
    <v-col cols="1" md="1" />
    <v-col cols="5" md="5">
      <v-card outlined class="rounded-xl" style="background-color:#212121;">
        <v-card-text>
          <v-form ref="form" @submit.prevent="sendEmail">
            <v-text-field
              label="Full Name"
              v-model="name"
              prepend-icon="person"
              :rules="nameRules"
              required
            />
            <v-text-field
              label="Email"
              v-model="email"
              prepend-icon="email"
              :rules="emailRules"
              required
            />
            <v-textarea
              label="Message"
              v-model="content"
              prepend-icon="edit"
              :rules="contentRules"
              required
            />
            <!-- <input type="submit" color="#082543" class="rounded-xl mr-4 white--text" value="Send" > -->
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="sendEmail" color="#082543" class="rounded-xl mr-4 white--text">
            <v-icon left>send</v-icon>
            <span>Send</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import emailjs from 'emailjs-com';
export default {
  data: () => ({
    name: "",
    nameRules: [
      v => !!v || "Name is required",
      v => v.length <= 20 || "Name must be less than 20 characters"
    ],
    content: "",
    contentRules: [
      v => !!v || "Content is required",
      v => v.length >= 10 || "Message must be more than 10 characters"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ]
  }),
  props: {
    contact: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },

  methods: {
    sendEmail(e){
      try {
        
        emailjs.sendForm('service_pabzscw', 'template_wchc16v', e.target,
        'user_lf0xNnNwdAbAZqurX8jI4', {
          from_name: this.name,
          email: this.email,
          message: this.content
        })

      } catch(error) {
          console.log({error})
      }
      // Reset form field
       this.name = ''
       this.email = ''
       this.content = ''
  
    }
  }
};
</script>